export class Ba1010Class {
    CompId : number;
    CompCod : string;
    CompNam : string;
    CompNamArabic : string;
    CompAdrs : string;
    CompAdrsArabic : string;
    FkCntryId : number;
    FkStateId : number;
    FkCityId : number;
    FkCurrId : number;
    ZipCod : string;
    Website : string;
    Email : string;
    Ph1 : string;
    Ph2 : string;
    Fax1 : string;
    Fax2 : string;
    Poboxno : string;
    Crno : string;
    VatNo : string;
    Ref1 : string;
    Ref2 : string;
    Ref3 : string;

    MdfdBy: number;
    MdfdOn: Date;
    ba1010History: Ba1010Class;
    CntryNam: string;
}
